import { getSalesOrderDemandById } from '../../redux/actions/salesOrderDemandActionCreators';
import { SalesOrderDemand } from '../../redux/types';

// A submitted order is searchable only once it is indexed, which normally takes a few seconds.
const SUBMITTED_ORDER_WAIT_MS = 10000;
const RETRY_INTERVAL_MS = 2500;
export const MAX_RETRIES = SUBMITTED_ORDER_WAIT_MS / RETRY_INTERVAL_MS;

const delay = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

/**
 * Polls for a sales order that was submitted but is not searchable yet. Resolves to null once the wait
 * runs out or the caller cancels. A failed lookup rejects immediately rather than being retried.
 */
export async function waitForSalesOrder(
    resellerId: string,
    purchaseOrderId: string,
    isCancelled: () => boolean,
    retriesLeft = MAX_RETRIES
): Promise<SalesOrderDemand | null> {
    if (retriesLeft === 0) return null;
    await delay(RETRY_INTERVAL_MS);
    if (isCancelled()) return null;
    const order = await getSalesOrderDemandById(resellerId, purchaseOrderId);
    return order || waitForSalesOrder(resellerId, purchaseOrderId, isCancelled, retriesLeft - 1);
}
